import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  sections: {
    maxHeight: 240,
    overflowY: 'auto',
    padding: '2px 0',
    fontWeight: 500,
  },
  value: {
    color: theme.palette.textColor.dark,
  },
}));
